module.exports = __webpack_public_path__ + "media/PAG66-11.46ae8de6.mp3";